module.exports = __webpack_public_path__ + "static/027.thumb-c4fa98cae6f8f5766656b83c897b61bc.jpg";